<section>
    <div class="subMenu">
        <span class="tex_menu" *ngFor="let item of breaddata ;let i=index" >
          <a href="{{item.url}}">{{item.name}}</a>
          <span *ngIf="breaddata.length!=(i+1)"> ></span>
          </span>
    </div>
</section>
